module.exports = __webpack_public_path__ + "images/my-integral-icon-present.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/my-integral-icon-present.png
// module id = 889
// module chunks = 121